import { ValueOf } from './common';

export type CampaignId = string;

export type IncludeQuery = ValueOf<typeof IncludeParams>;

export const IncludeParams = {
  PRICING: 'pricing',
} as const;
